import React, { useEffect, useState } from "react";
import silentSound from "../assets/sounds/almost-silent-2.mp3";

export const SilentAudioItem = () => {
  const [sound, setSound] = useState(new Audio());

  useEffect(() => {
    if (!sound.src) {
      setSound((prev) => {
        prev.setAttribute("src", silentSound);
        prev.setAttribute("loop", true);
        prev.load();

        prev.loop = true;
        prev.volume = 0.01;
        prev.play();

        return prev;
      });
    }
  }, [sound]);

  return <></>;
};
